import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppModuleGlobalShared } from 'src/app/app.module.global';
import { CoreModule } from '../../core/core.module';
import { AlertaProductoRechazadoFilterComponent } from './alertasProductosRechazados/alertaProductoRechazado-filter/alertaProductoRechazado-filter.component';
import { AlertaProductoRechazadoListComponent } from './alertasProductosRechazados/alertaProductoRechazado-list/alertaProductoRechazado-list.component';
import { AlertaProductoRechazadoWrapperComponent } from './alertasProductosRechazados/alertaProductoRechazado-wrapper/alertaProductoRechazado-wrapper.component';
import { AlertaProductoRechazadoService } from './alertasProductosRechazados/alertaProductoRechazado.service';
import { AlertasRoutingModule } from './alertas-routing.module';
import { AlertaProductoRechazadoExFilterComponent } from './alertasProductosRechazadosEx/alertaProductoRechazadoEx-filter/alertaProductoRechazadoEx-filter.component';
import { AlertaProductoRechazadoExListComponent } from './alertasProductosRechazadosEx/alertaProductoRechazadoEx-list/alertaProductoRechazadoEx-list.component';
import { AlertaProductoRechazadoExWrapperComponent } from './alertasProductosRechazadosEx/alertaProductoRechazadoEx-wrapper/alertaProductoRechazadoEx-wrapper.component';
import { AlertaProductoRechazadoExService } from './alertasProductosRechazadosEx/alertaProductoRechazadoEx.service';
import { AlertaMatriculaRechazadaFilterComponent } from './alertasMatriculasRechazadas/alertaMatriculaRechazada-filter/alertaMatriculaRechazada-filter.component';
import { AlertaMatriculaRechazadaListComponent } from './alertasMatriculasRechazadas/alertaMatriculaRechazada-list/alertaMatriculaRechazada-list.component';
import { AlertaMatriculaRechazadaWrapperComponent } from './alertasMatriculasRechazadas/alertaMatriculaRechazada-wrapper/alertaMatriculaRechazada-wrapper.component';
import { AlertaMatriculaRechazadaService } from './alertasMatriculasRechazadas/alertaMatriculaRechazada.service';

@NgModule({
    declarations: [
        AlertaProductoRechazadoFilterComponent,
        AlertaProductoRechazadoListComponent,
        AlertaProductoRechazadoWrapperComponent,
        AlertaProductoRechazadoExFilterComponent,
        AlertaProductoRechazadoExListComponent,
        AlertaProductoRechazadoExWrapperComponent,
        AlertaMatriculaRechazadaFilterComponent,
        AlertaMatriculaRechazadaListComponent,
        AlertaMatriculaRechazadaWrapperComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, CommonModule, FormsModule, ReactiveFormsModule, AlertasRoutingModule],
    providers: [AlertaProductoRechazadoService, AlertaProductoRechazadoExService, AlertaMatriculaRechazadaService],
})
export class AlertasModule {}
